module.exports = __webpack_public_path__ + "img/Banner-Popup-Icon.62f0fa4b.jpg";